import { useState } from 'react';
import { default as FormattedMessage } from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import H2 from 'UIComponents/elements/headings/H2';
import H4 from 'UIComponents/elements/headings/H4';
import UIFormControl from 'UIComponents/form/UIFormControl';
import { BusinessUnitsRebrandMessage } from 'ui-business-units-lib/components/BusinessUnitsRebrandMessage';
import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import WithBusinessUnitsDataFetching from 'ui-business-units-lib/utils/WithBusinessUnitsDataFetching';
// @ts-expect-error Untyped import
import { useHideDialog } from '../../../dialog/ducks';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BusinessUnitSelectWithData = WithBusinessUnitsDataFetching(BusinessUnitSelect);
const SetAssetBusinessUnitModal = ({
  AssetCountLabel,
  descriptionKey,
  initialValue,
  onSave
}) => {
  const closeDialog = useHideDialog();
  const [businessUnit, setBusinessUnit] = useState(initialValue);
  return /*#__PURE__*/_jsxs(UIModal, {
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: closeDialog
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.title",
          rebrandMessage: "reporting-action-components.actions.setBusinessUnit.dialog.title_buv2"
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [AssetCountLabel && /*#__PURE__*/_jsx(H4, {
        children: AssetCountLabel
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.prompt",
          rebrandMessage: "reporting-action-components.actions.setBusinessUnit.dialog.prompt_buv2"
        }),
        help: /*#__PURE__*/_jsx(FormattedMessage, {
          message: descriptionKey
        }),
        children: /*#__PURE__*/_jsx(BusinessUnitSelectWithData, {
          buId: businessUnit,
          onChange: buId => {
            setBusinessUnit(buId);
          }
        })
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UIButton, {
        use: "primary",
        onClick: () => onSave(businessUnit),
        disabled: initialValue === businessUnit,
        children: /*#__PURE__*/_jsx(BusinessUnitsRebrandMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.confirm",
          rebrandMessage: "reporting-action-components.actions.setBusinessUnit.dialog.confirm_buv2"
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        use: "secondary",
        onClick: closeDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.actions.setBusinessUnit.dialog.reject"
        })
      })]
    })]
  });
};
export default SetAssetBusinessUnitModal;